import React, { Fragment, useState, useEffect, useLayoutEffect, useRef } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import "./KYC-Dashboard.css";
import {
	imgFilter,
	KYCAccountNameImage,
	KYCContactsImage,
	KYCCylindersImage,
	KYCDesignImage,
	KYCGroupCompanyImage,
	KYCMaterialsImage,
} from "../Elite/imageAssets";
import { Spin, Input, Card, Tabs, Select, DatePicker, Button } from "antd";
import {
	EnvironmentFilled,
	EnvironmentOutlined,
	MinusOutlined,
	PlusOutlined,
	UnorderedListOutlined,
} from "@ant-design/icons";
import { NotificationManager } from "react-notifications";
import { GoogleMap, LoadScript, Marker } from "@react-google-maps/api";
import KycService from "../../services/kyc-service";
import KycGroupCompanyTab from "./KycGroupCompanyTab";
import KycAccountTab from "./KycAccountTab";
import KycMaterialsTab from "./KycMaterialsTab";
import moment from "moment";

const { Search } = Input;
const { TabPane } = Tabs;
const { Option } = Select;

const mapFilterOptions = {
	groupCompanies: ["Knack Packaging", "Adinath Enterprise", "Punjab Poly Pack"],
	companies: ["Company Name", "Amritsar Packaging", "Ludhiana Flexibles"],
	locations: ["Punjab", "Uttarakhand", "Haryana"],
};

const mapMarkers = [
	{ id: 1, type: "selected", position: { lat: 31.634, lng: 74.872 }, title: "Selected Company" },
	{ id: 2, type: "company", position: { lat: 31.52, lng: 75.11 }, title: "Company" },
	{ id: 3, type: "company", position: { lat: 30.9, lng: 75.85 }, title: "Company" },
	{ id: 4, type: "group", position: { lat: 30.82, lng: 75.17 }, title: "Group Company" },
	{ id: 5, type: "company", position: { lat: 30.68, lng: 74.77 }, title: "Company" },
	{ id: 6, type: "group", position: { lat: 30.72, lng: 76.12 }, title: "Group Company" },
	{ id: 7, type: "company", position: { lat: 30.2, lng: 74.5 }, title: "Company" },
	{ id: 8, type: "group", position: { lat: 30.13, lng: 74.72 }, title: "Group Company" },
	{ id: 9, type: "company", position: { lat: 30.38, lng: 76.77 }, title: "Company" },
	{ id: 10, type: "group", position: { lat: 30.37, lng: 76.14 }, title: "Group Company" },
	{ id: 11, type: "company", position: { lat: 30.34, lng: 77.95 }, title: "Company" },
	{ id: 12, type: "group", position: { lat: 30.13, lng: 77.29 }, title: "Group Company" },
	{ id: 13, type: "company", position: { lat: 30.52, lng: 78.05 }, title: "Company" },
	{ id: 14, type: "group", position: { lat: 30.1, lng: 78.28 }, title: "Group Company" },
	{ id: 15, type: "company", position: { lat: 30.73, lng: 78.44 }, title: "Company" },
	{ id: 16, type: "group", position: { lat: 30.23, lng: 78.62 }, title: "Group Company" },
	{ id: 17, type: "company", position: { lat: 30.41, lng: 79.32 }, title: "Company" },
	{ id: 18, type: "company", position: { lat: 29.95, lng: 78.16 }, title: "Company" },
	{ id: 19, type: "group", position: { lat: 30.18, lng: 77.55 }, title: "Group Company" },
	{ id: 20, type: "company", position: { lat: 30.15, lng: 75.55 }, title: "Company" },
];

const mapCenter = { lat: 30.86, lng: 76.95 };
const googleMapApiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
const googleMapOptions = {
	mapTypeControl: false,
	fullscreenControl: false,
	streetViewControl: false,
	zoomControl: false,
	clickableIcons: false,
	disableDefaultUI: true,
	mapTypeId: "roadmap",
};

const createMarkerIcon = (color) =>
	`data:image/svg+xml;charset=UTF-8,${encodeURIComponent(`
		<svg width="34" height="46" viewBox="0 0 34 46" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M17 45C17 45 31 29.36 31 17C31 8.72 24.73 2 17 2C9.27 2 3 8.72 3 17C3 29.36 17 45 17 45Z" fill="${color}" stroke="white" stroke-width="3"/>
			<circle cx="17" cy="17" r="6.3" fill="white"/>
			<circle cx="17" cy="17" r="2.8" fill="${color}"/>
		</svg>
	`)}`;

const markerIcons = {
	group: createMarkerIcon("#d74854"),
	company: createMarkerIcon("#3fb9e0"),
	selected: createMarkerIcon("#192936"),
};

const accountInfoItems = [
	["Particular:", "01|04|2023 to Today", "Invoice:", "7"],
	["Total Num of Bags:", "7,00,000.00", "Material:", "9"],
	["Basic Value:", "7,00,000.00", "Total Weight of Bag:", "7000 MT"],
	["Avg wt per Bag:", "0.100 KG", "Avg rate per Bag:", "10"],
	["Avg rate per Kg:", "100", "Cylinders:", "9"],
];

const defaultPayload = {
	fromDate: "2026-04-09T12:10:21.201Z",
	toDate: "2026-04-09T12:10:21.201Z",
	distributionChannel: "",
	priceGroup: "",
	salesDistrict: "",
	salesOffice: "",
	country: "",
	director: "",
	generalManager: "",
	continentalManager: "",
	regionalManager: "",
	areaManager: "",
	customerGroup: "",
	materialGroup: "",
	materialType: "",
	materialDivision: "",
	materialStructure: "",
	materialCharacteristics: "",
	materialHierarchy1: "",
	materialHierarchy2: "",
	materialHierarchy3: "",
};

const getFirstAvailableValue = (...values) =>
	values.find((value) => value !== undefined && value !== null && value !== "");
const defaultFilterValues = {
	fromDate: null,
	toDate: null,
	distributionChannel: [],
	priceGroup: [],
	salesDistrict: [],
	salesOffice: [],
	country: [],
	director: [],
	generalManager: [],
	continentalManager: [],
	regionalManager: [],
	areaManager: [],
	customerGroup: [],
	materialGroup: [],
	materialType: [],
	materialDivision: [],
	materialStructure: [],
	materialCharacteristics: [],
	materialHierarchy1: [],
	materialHierarchy2: [],
	materialHierarchy3: [],
};

const formatMultiSelectPayloadValue = (value) => {
	if (Array.isArray(value)) {
		return value.length ? value.join(",") : "";
	}
	return value || "";
};
const getFilterOptionList = (responseData, keys) => {
	for (const key of keys) {
		const value = responseData?.[key];
		if (Array.isArray(value)) {
			return value;
		}
	}

	return [];
};
const normalizeFilterOptions = (options = []) =>
	options
		.map((item, index) => {
			if (typeof item === "string" || typeof item === "number") {
				return { label: item, value: item, key: `${item}-${index}` };
			}

			if (!item || typeof item !== "object") {
				return null;
			}

			const value =
				item.value ??
				item.id ??
				item.sapCode ??
				item.code ??
				item.name ??
				item.label ??
				item.text ??
				item.title ??
				item.key;
			const label =
				item.label ??
				item.name ??
				item.text ??
				item.title ??
				item.value ??
				item.code ??
				item.sapCode ??
				item.id;

			if (value === undefined || label === undefined) {
				return null;
			}

			return {
				label,
				value,
				key: `${value}-${index}`,
			};
		})
		.filter(Boolean);
const getGroupCompanyId = (record) =>
	record?.groupcomanyId ||
	record?.groupCompanyId ||
	record?.id ||
	record?.groupCompanyMasterId ||
	record?.ispl_GroupCompanyId ||
	"";

const getAccountRowCompanyName = (record = {}) => {
	for (const key of ["accountName", "companyName", "ispl_AccountName", "ispl_accountName"]) {
		const v = record[key];
		if (v !== undefined && v !== null && String(v).trim() !== "") {
			return String(v).trim();
		}
	}
	return "";
};

const VALID_COMPANY_NAV_TAB_KEYS = new Set([
	"groupCompany",
	"account",
	"materials",
	"quotation",
	"orders",
	"design",
]);

const readCompanyNavTabFromWindow = () => {
	if (typeof window === "undefined") {
		return "groupCompany";
	}
	const tab = new URLSearchParams(window.location.search).get("companyTab");
	return tab && VALID_COMPANY_NAV_TAB_KEYS.has(tab) ? tab : "groupCompany";
};

const readKycViewModeFromWindow = () => {
	if (typeof window === "undefined") {
		return "list";
	}
	return window.location.pathname === "/kyc/map" ? "map" : "list";
};

const KycDashboard = () => {
	const navigate = useNavigate();
	const location = useLocation();
	const [searchParams, setSearchParams] = useSearchParams();
	const [isCardsLoading, setIsCardsLoading] = useState(false);
	const [activeCompanyTab, setActiveCompanyTab] = useState(readCompanyNavTabFromWindow);
	const [selectedGroupCompanyId, setSelectedGroupCompanyId] = useState("");

	useEffect(() => {
		const tab = searchParams.get("companyTab");
		const resolved = tab && VALID_COMPANY_NAV_TAB_KEYS.has(tab) ? tab : "groupCompany";
		setActiveCompanyTab((prev) => (resolved !== prev ? resolved : prev));
	}, [searchParams]);

	useEffect(() => {
		const nextMode = location.pathname === "/kyc/map" ? "map" : "list";
		setKycViewMode((prev) => (prev !== nextMode ? nextMode : prev));
	}, [location.pathname]);
	const [groupCompanyTable, setGroupCompanyTable] = useState({
		rows: [],
		totalRecords: 0,
		currentPage: 1,
		pageSize: 10,
	});
	const [accountTable, setAccountTable] = useState({
		rows: [],
		totalRecords: 0,
		currentPage: 1,
		pageSize: 10,
	});
	const [materialsTable, setMaterialsTable] = useState({
		rows: [],
		totalRecords: 0,
		currentPage: 1,
		pageSize: 10,
	});
	const [isGroupCompanyLoading, setIsGroupCompanyLoading] = useState(false);
	const [isAccountLoading, setIsAccountLoading] = useState(false);
	const [isMaterialsLoading, setIsMaterialsLoading] = useState(false);
	const [isFiltersLoading, setIsFiltersLoading] = useState(false);
	const [isFiltersExpanded, setIsFiltersExpanded] = useState(true);
	const [filterPanelHeight, setFilterPanelHeight] = useState(0);
	const [tableSearchValue, setTableSearchValue] = useState("");
	const [kycViewMode, setKycViewMode] = useState(readKycViewModeFromWindow);
	const filterPanelContentRef = useRef(null);
	const [filterValues, setFilterValues] = useState(defaultFilterValues);
	const [filterOptions, setFilterOptions] = useState({
		distributionChannel: [],
		priceGroup: [],
		salesDistrict: [],
		salesOffice: [],
		country: [],
		director: [],
		generalManager: [],
		continentalManager: [],
		regionalManager: [],
		areaManager: [],
		customerGroup: [],
		materialGroup: [],
		materialType: [],
		materialDivision: [],
		materialStructure: [],
		materialCharacteristics: [],
		materialHierarchy1: [],
		materialHierarchy2: [],
		materialHierarchy3: [],
	});
	const [groupCompanySorter, setGroupCompanySorter] = useState({
		field: "CreatedOn",
		order: "DESC",
	});
	const [accountSorter, setAccountSorter] = useState({
		field: "CreatedOn",
		order: "DESC",
	});
	const [materialsSorter, setMaterialsSorter] = useState({
		field: "createdon",
		order: "DESC",
	});
	const [materialsIsplCustomer, setMaterialsIsplCustomer] = useState("");

	// --- Individual card count states (mirrors O2W pattern) ---
	const [groupCompanyCount, setGroupCompanyCount] = useState({});
	const [accountNameCount, setAccountNameCount] = useState({});
	const [contactsCount, setContactsCount] = useState({});
	const [materialsCount, setMaterialsCount] = useState({});
	const [designsCount, setDesignsCount] = useState({});
	const [cylindersCount, setCylindersCount] = useState({});

	const getCardTitle = (countObj, label, keys = ["total"]) => {
		const countValue = getFirstAvailableValue(...keys.map((key) => countObj?.[key]));
		return countValue !== undefined ? `${countValue} ${label}` : label;
	};

	const getCardCountValue = (countObj, keys) => {
		if (!countObj || Object.keys(countObj).length === 0) {
			return "-";
		}

		const countValue = getFirstAvailableValue(...keys.map((key) => countObj?.[key]));
		return countValue !== undefined ? countValue : "-";
	};

	const buildKycFilterPayload = () => ({
		...defaultPayload,
		fromDate: filterValues.fromDate ? moment(filterValues.fromDate).toISOString() : defaultPayload.fromDate,
		toDate: filterValues.toDate ? moment(filterValues.toDate).toISOString() : defaultPayload.toDate,
		distributionChannel: formatMultiSelectPayloadValue(filterValues.distributionChannel),
		priceGroup: formatMultiSelectPayloadValue(filterValues.priceGroup),
		salesDistrict: formatMultiSelectPayloadValue(filterValues.salesDistrict),
		salesOffice: formatMultiSelectPayloadValue(filterValues.salesOffice),
		country: formatMultiSelectPayloadValue(filterValues.country),
		director: formatMultiSelectPayloadValue(filterValues.director),
		generalManager: formatMultiSelectPayloadValue(filterValues.generalManager),
		continentalManager: formatMultiSelectPayloadValue(filterValues.continentalManager),
		regionalManager: formatMultiSelectPayloadValue(filterValues.regionalManager),
		areaManager: formatMultiSelectPayloadValue(filterValues.areaManager),
		customerGroup: formatMultiSelectPayloadValue(filterValues.customerGroup),
		materialGroup: formatMultiSelectPayloadValue(filterValues.materialGroup),
		materialType: formatMultiSelectPayloadValue(filterValues.materialType),
		materialDivision: formatMultiSelectPayloadValue(filterValues.materialDivision),
		materialStructure: formatMultiSelectPayloadValue(filterValues.materialStructure),
		materialCharacteristics: formatMultiSelectPayloadValue(filterValues.materialCharacteristics),
		materialHierarchy1: formatMultiSelectPayloadValue(filterValues.materialHierarchy1),
		materialHierarchy2: formatMultiSelectPayloadValue(filterValues.materialHierarchy2),
		materialHierarchy3: formatMultiSelectPayloadValue(filterValues.materialHierarchy3),
	});

	function buildKycTileCountsPayload() {
		const payload = { ...buildKycFilterPayload() };
		if (selectedGroupCompanyId) {
			payload.groupcomanyId = String(selectedGroupCompanyId).trim();
		}
		if (materialsIsplCustomer && String(materialsIsplCustomer).trim()) {
			payload.ispl_customer = String(materialsIsplCustomer).trim();
		}
		return payload;
	}

	const filterPayloadSignature = JSON.stringify(buildKycFilterPayload());

	useEffect(() => {
		handleGetKycGlobalFilters();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		handleGetKycDashboardCount();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [filterPayloadSignature, selectedGroupCompanyId, materialsIsplCustomer]);

	useEffect(() => {
		const timeout = setTimeout(() => {
			if (activeCompanyTab === "groupCompany") {
				handleGetGroupCompanyList();
			}
		}, 500);

		return () => clearTimeout(timeout);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [
		activeCompanyTab,
		filterPayloadSignature,
		tableSearchValue,
		groupCompanySorter.field,
		groupCompanySorter.order,
		groupCompanyTable.currentPage,
	]);

	useEffect(() => {
		if (activeCompanyTab !== "account") {
			return undefined;
		}

		const timeout = setTimeout(() => {
			handleGetAccountList();
		}, 500);

		return () => clearTimeout(timeout);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [
		activeCompanyTab,
		selectedGroupCompanyId,
		filterPayloadSignature,
		tableSearchValue,
		accountSorter.field,
		accountSorter.order,
		accountTable.currentPage,
	]);

	useEffect(() => {
		if (activeCompanyTab !== "materials") {
			return undefined;
		}

		const timeout = setTimeout(() => {
			handleGetMaterialsList();
		}, 500);

		return () => clearTimeout(timeout);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [
		activeCompanyTab,
		filterPayloadSignature,
		tableSearchValue,
		materialsSorter.field,
		materialsSorter.order,
		materialsTable.currentPage,
		materialsIsplCustomer,
	]);

	useLayoutEffect(() => {
		const contentNode = filterPanelContentRef.current;
		if (!contentNode) {
			return undefined;
		}

		const updateHeight = () => {
			setFilterPanelHeight(contentNode.scrollHeight);
		};
		const animationFrame = window.requestAnimationFrame(updateHeight);

		updateHeight();

		if (typeof ResizeObserver !== "undefined") {
			const resizeObserver = new ResizeObserver(() => {
				updateHeight();
			});
			resizeObserver.observe(contentNode);
			return () => {
				window.cancelAnimationFrame(animationFrame);
				resizeObserver.disconnect();
			};
		}

		window.addEventListener("resize", updateHeight);
		return () => {
			window.cancelAnimationFrame(animationFrame);
			window.removeEventListener("resize", updateHeight);
		};
	}, [isFiltersExpanded, isFiltersLoading, filterOptions, kycViewMode]);

	function buildGroupCompanyListPayload() {
		return {
			pageindex: groupCompanyTable.currentPage,
			pagesize: groupCompanyTable.pageSize,
			sortcolumn: groupCompanySorter.field,
			orderBy: groupCompanySorter.order,
			search: tableSearchValue ? tableSearchValue.trim() : "",
			...buildKycFilterPayload(),
		};
	}

	function buildAccountListPayload() {
		const payload = {
			pageindex: accountTable.currentPage,
			pagesize: accountTable.pageSize,
			sortcolumn: accountSorter.field,
			orderBy: accountSorter.order,
			search: tableSearchValue ? tableSearchValue.trim() : "",
			...buildKycFilterPayload(),
		};

		if (selectedGroupCompanyId) {
			payload.groupcomanyId = selectedGroupCompanyId;
		}

		return payload;
	}

	function buildMaterialListPayload() {
		return {
			pageindex: materialsTable.currentPage,
			pagesize: materialsTable.pageSize,
			sortcolumn: materialsSorter.field,
			orderBy: materialsSorter.order,
			search: tableSearchValue ? tableSearchValue.trim() : "",
			...buildKycFilterPayload(),
			ispl_customer: materialsIsplCustomer ? materialsIsplCustomer.trim() : "",
		};
	}

	function handleGetKycGlobalFilters() {
		setIsFiltersLoading(true);
		KycService.getKycGlobalFiltersAPI()
			.then((response) => {
				const success = response.data?.statusCode === 200 || response.data?.status === true;
				if (success) {
					const responseData = response.data?.responseData || response.data || {};
					setFilterOptions({
						distributionChannel: normalizeFilterOptions(
							getFilterOptionList(responseData, ["distributionChannels", "distributionChannel", "distChannels"])
						),
						priceGroup: normalizeFilterOptions(
							getFilterOptionList(responseData, ["priceGroups", "priceGroup"])
						),
						salesDistrict: normalizeFilterOptions(
							getFilterOptionList(responseData, ["salesDistricts", "salesDistrict"])
						),
						salesOffice: normalizeFilterOptions(
							getFilterOptionList(responseData, ["salesOffices", "salesOffice"])
						),
						country: normalizeFilterOptions(getFilterOptionList(responseData, ["countries", "country"])),
						director: normalizeFilterOptions(getFilterOptionList(responseData, ["directors", "director"])),
						generalManager: normalizeFilterOptions(
							getFilterOptionList(responseData, ["generalManagers", "generalManager"])
						),
						continentalManager: normalizeFilterOptions(
							getFilterOptionList(responseData, ["continentalManagers", "continentalManager"])
						),
						regionalManager: normalizeFilterOptions(
							getFilterOptionList(responseData, ["regionalManagers", "regionalManager"])
						),
						areaManager: normalizeFilterOptions(getFilterOptionList(responseData, ["areaManagers", "areaManager"])),
						customerGroup: normalizeFilterOptions(
							getFilterOptionList(responseData, ["customerGroups", "customerGroup"])
						),
						materialGroup: normalizeFilterOptions(
							getFilterOptionList(responseData, ["materialGroups", "materialGroup"])
						),
						materialType: normalizeFilterOptions(
							getFilterOptionList(responseData, ["materialTypes", "materialType"])
						),
						materialDivision: normalizeFilterOptions(
							getFilterOptionList(responseData, ["materialDivisions", "materialDivision"])
						),
						materialStructure: normalizeFilterOptions(
							getFilterOptionList(responseData, ["materialStructures", "materialStructure"])
						),
						materialCharacteristics: normalizeFilterOptions(
							getFilterOptionList(responseData, ["materialCharacteristics", "materialCharacteristic"])
						),
						materialHierarchy1: normalizeFilterOptions(
							getFilterOptionList(responseData, ["materialHierarchy1", "materialHierarchies1"])
						),
						materialHierarchy2: normalizeFilterOptions(
							getFilterOptionList(responseData, ["materialHierarchy2", "materialHierarchies2"])
						),
						materialHierarchy3: normalizeFilterOptions(
							getFilterOptionList(responseData, ["materialHierarchy3", "materialHierarchies3"])
						),
					});
				} else {
					NotificationManager.error(response.data?.message || "Unable to load KYC global filters.");
				}
			})
			.catch((error) => {
				console.log(error, "Error");
				NotificationManager.error("Unable to load KYC global filters.");
			})
			.finally(() => {
				setIsFiltersLoading(false);
			});
	}

	function handleGetGroupCompanyList() {
		setIsGroupCompanyLoading(true);
		const requestData = buildGroupCompanyListPayload();
		KycService.getKycGroupCompanyListAPI(requestData)
			.then((response) => {
				const success = response.data?.statusCode === 200 || response.data?.status === true;
				if (success) {
					const responseData = response.data.responseData || {};
					const groupCompanyList = Array.isArray(responseData)
						? responseData
						: responseData.kycGroupCompanyLists ||
						responseData.groupCompanyListing ||
						responseData.groupCompanyList ||
						responseData.data ||
						[];
					const totalRecords = Number(responseData.totalRecords || groupCompanyList.length || 0);
					const currentPage = Number(responseData.currentPage || groupCompanyTable.currentPage);

					setGroupCompanyTable((prev) => ({
						...prev,
						rows: groupCompanyList,
						totalRecords,
						currentPage,
					}));
				} else {
					NotificationManager.error(response.data?.message || "Unable to load Group Company listing.");
				}
			})
			.catch((error) => {
				console.log(error, "Error");
				NotificationManager.error("Unable to load Group Company listing.");
			})
			.finally(() => {
				setIsGroupCompanyLoading(false);
			});
	}

	function handleGetAccountList() {
		setIsAccountLoading(true);
		const requestData = buildAccountListPayload();
		KycService.getKycCompanyListAPI(requestData)
			.then((response) => {
				const success = response.data?.statusCode === 200 || response.data?.status === true;
				if (success) {
					const responseData = response.data.responseData || {};
					const accountList = Array.isArray(responseData)
						? responseData
						: responseData.kycCompanyLists ||
						responseData.kycGroupCompanyLists ||
						responseData.companyListing ||
						responseData.companyList ||
						responseData.data ||
						[];
					const totalRecords = Number(responseData.totalRecords || accountList.length || 0);
					const currentPage = Number(responseData.currentPage || accountTable.currentPage);

					setAccountTable((prev) => ({
						...prev,
						rows: accountList,
						totalRecords,
						currentPage,
					}));
				} else {
					NotificationManager.error(response.data?.message || "Unable to load Account listing.");
				}
			})
			.catch((error) => {
				console.log(error, "Error");
				NotificationManager.error("Unable to load Account listing.");
			})
			.finally(() => {
				setIsAccountLoading(false);
			});
	}

	function handleGetMaterialsList() {
		setIsMaterialsLoading(true);
		const requestData = buildMaterialListPayload();
		KycService.getKycMaterialMasterListAPI(requestData)
			.then((response) => {
				const success = response.data?.statusCode === 200 || response.data?.status === true;
				if (success) {
					const responseData = response.data.responseData || {};
					const materialList = Array.isArray(responseData)
						? responseData
						: responseData.kycMaterialMasterLists ||
						responseData.kycMaterialMasterList ||
						responseData.materialMasterList ||
						responseData.data ||
						[];
					const totalRecords = Number(responseData.totalRecords || materialList.length || 0);
					const rawPage = responseData.currentPage;
					const parsedPage = Number(rawPage);
					const currentPage =
						rawPage !== undefined && rawPage !== null && rawPage !== "" && !Number.isNaN(parsedPage)
							? parsedPage
							: materialsTable.currentPage;

					setMaterialsTable((prev) => ({
						...prev,
						rows: materialList,
						totalRecords,
						currentPage,
					}));
				} else {
					NotificationManager.error(response.data?.message || "Unable to load Materials listing.");
				}
			})
			.catch((error) => {
				console.log(error, "Error");
				NotificationManager.error("Unable to load Materials listing.");
			})
			.finally(() => {
				setIsMaterialsLoading(false);
			});
	}

	const handleTableSearchChange = (event) => {
		setTableSearchValue(event.target.value);
		if (activeCompanyTab === "account") {
			setAccountTable((prev) => ({ ...prev, currentPage: 1 }));
			return;
		}
		if (activeCompanyTab === "materials") {
			setMaterialsTable((prev) => ({ ...prev, currentPage: 1 }));
			return;
		}
		setGroupCompanyTable((prev) => ({ ...prev, currentPage: 1 }));
	};

	const handleGroupCompanyTableChange = ({ currentPage, sortColumn, orderBy, pageSize }) => {
		setGroupCompanyTable((prev) => ({
			...prev,
			currentPage,
			pageSize: pageSize || prev.pageSize,
		}));
		setGroupCompanySorter((prev) => ({
			field: sortColumn ?? prev.field,
			order: orderBy ?? prev.order,
		}));
	};

	const handleAccountTableChange = ({ currentPage, sortColumn, orderBy, pageSize }) => {
		setAccountTable((prev) => ({
			...prev,
			currentPage,
			pageSize: pageSize || prev.pageSize,
		}));
		setAccountSorter((prev) => ({
			field: sortColumn ?? prev.field,
			order: orderBy ?? prev.order,
		}));
	};

	const handleMaterialsTableChange = ({ currentPage, sortColumn, orderBy, pageSize }) => {
		setMaterialsTable((prev) => ({
			...prev,
			currentPage,
			pageSize: pageSize || prev.pageSize,
		}));
		setMaterialsSorter((prev) => ({
			field: sortColumn ?? prev.field,
			order: orderBy ?? prev.order,
		}));
	};

	const handleFilterValueChange = (field, value) => {
		setFilterValues((prev) => ({ ...prev, [field]: value ?? [] }));
		setGroupCompanyTable((prev) => ({ ...prev, currentPage: 1 }));
		setAccountTable((prev) => ({ ...prev, currentPage: 1 }));
		setMaterialsTable((prev) => ({ ...prev, currentPage: 1 }));
	};

	const handleResetFilters = () => {
		setFilterValues(defaultFilterValues);
		setGroupCompanyTable((prev) => ({ ...prev, currentPage: 1 }));
		setAccountTable((prev) => ({ ...prev, currentPage: 1 }));
		setMaterialsTable((prev) => ({ ...prev, currentPage: 1 }));
		setMaterialsIsplCustomer("");
		setSelectedGroupCompanyId("");
	};

	const persistCompanyNavTabToUrl = (key) => {
		setSearchParams(
			(prev) => {
				const next = new URLSearchParams(prev);
				if (key === "groupCompany") {
					next.delete("companyTab");
				} else {
					next.set("companyTab", key);
				}
				return next;
			},
			{ replace: true }
		);
	};

	const handleViewModeChange = (mode) => {
		const targetPath = mode === "map" ? "/kyc/map" : "/kyc";
		const currentSearch = searchParams.toString();

		setKycViewMode(mode);
		navigate(
			{
				pathname: targetPath,
				search: currentSearch ? `?${currentSearch}` : "",
			},
			{ replace: true }
		);
	};

	const handleOpenMaterialsForAccountCustomer = (record) => {
		const name = getAccountRowCompanyName(record);
		if (!name) {
			NotificationManager.warning("Company name is not available for this account.");
			return;
		}
		setMaterialsIsplCustomer(name);
		setMaterialsTable((prev) => ({ ...prev, currentPage: 1 }));
		setActiveCompanyTab("materials");
		persistCompanyNavTabToUrl("materials");
	};

	const handleCompanyTabChange = (key) => {
		if (activeCompanyTab === "materials" && key !== "materials") {
			setMaterialsIsplCustomer("");
		}
		setActiveCompanyTab(key);
		persistCompanyNavTabToUrl(key);
		if (key === "groupCompany") {
			setSelectedGroupCompanyId("");
			setGroupCompanyTable((prev) => ({ ...prev, currentPage: 1 }));
		}
		if (key === "account") {
			setSelectedGroupCompanyId("");
			setAccountTable((prev) => ({ ...prev, currentPage: 1 }));
		}
		if (key === "materials") {
			setMaterialsTable((prev) => ({ ...prev, currentPage: 1 }));
		}
	};

	const handleOpenAccountTab = (record) => {
		const nextGroupCompanyId = getGroupCompanyId(record);
		if (!nextGroupCompanyId) {
			return;
		}

		setMaterialsIsplCustomer("");
		setSelectedGroupCompanyId(String(nextGroupCompanyId));
		setAccountTable((prev) => ({ ...prev, currentPage: 1, rows: [] }));
		setActiveCompanyTab("account");
		persistCompanyNavTabToUrl("account");
	};

	function handleGetKycDashboardCount() {
		setIsCardsLoading(true);
		KycService.getKycTileCountsAPI(buildKycTileCountsPayload())
			.then((response) => {
				if (response.data?.statusCode === 200) {
					const apiData = response.data.responseData || {};

					setGroupCompanyCount(apiData.groupCompany ? apiData.groupCompany : {});
					setAccountNameCount(apiData.company ? apiData.company : {});
					setContactsCount(apiData.contacts ? apiData.contacts : {});
					setMaterialsCount(apiData.materials ? apiData.materials : {});
					setDesignsCount(apiData.designs ? apiData.designs : {});
					setCylindersCount(apiData.cylinders ? apiData.cylinders : {});

					setIsCardsLoading(false);
				} else {
					NotificationManager.error(response.data.message);
					setIsCardsLoading(false);
				}
			})
			.catch((error) => {
				setIsCardsLoading(false);
				console.log(error, "Error");
			});
	}

	const filterFieldConfigs = [
		{ key: "distributionChannel", placeholder: "Dist. Channel" },
		{ key: "priceGroup", placeholder: "Price Group" },
		{ key: "salesDistrict", placeholder: "Sales District" },
		{ key: "salesOffice", placeholder: "Sales Office" },
		{ key: "country", placeholder: "Country" },
		{ key: "director", placeholder: "Director" },
		{ key: "generalManager", placeholder: "General Manager" },
		{ key: "continentalManager", placeholder: "Continental Manager" },
		{ key: "regionalManager", placeholder: "Regional Manager" },
		{ key: "areaManager", placeholder: "Area Manager" },
		{ key: "customerGroup", placeholder: "Customer Group" },
		{ key: "materialGroup", placeholder: "Material Group" },
		{ key: "materialType", placeholder: "Material Type" },
		{ key: "materialDivision", placeholder: "Material Division Name" },
		{ key: "materialStructure", placeholder: "Material Structure Name" },
		{ key: "materialCharacteristics", placeholder: "Material Characteristics" },
		{ key: "materialHierarchy1", placeholder: "Material Hierarchy - 1" },
		{ key: "materialHierarchy2", placeholder: "Material Hierarchy - 2" },
		{ key: "materialHierarchy3", placeholder: "Material Hierarchy - 3" },
	];

	const renderViewSwitch = () => (
		<div className="kyc-view-switch-wrap">
			<div className="kyc-view-switch" role="group" aria-label="KYC view">
				<button
					type="button"
					className={`kyc-view-switch-btn ${kycViewMode === "list" ? "active" : ""}`}
					onClick={() => handleViewModeChange("list")}>
					<UnorderedListOutlined />
					<span>List</span>
				</button>
				<button
					type="button"
					className={`kyc-view-switch-btn ${kycViewMode === "map" ? "active" : ""}`}
					onClick={() => handleViewModeChange("map")}>
					<EnvironmentOutlined />
					<span>Map</span>
				</button>
			</div>
		</div>
	);

	return (
		<Fragment>
			<div className="dashboard app-content content">
				<div className="content-wrapper">
					<div className="content-body">
						{renderViewSwitch()}
						{kycViewMode === "map" ? (
							<KycMapView />
						) : (
							<Fragment>
						<Spin size="large" spinning={isCardsLoading}>
							<div className="row">
								{/* Card 1 - Groups Company */}
								<div className="col-xl-4 col-lg-6 col-12">
									<div className="card kycbg_green">
										<div className="card-content">
											<div className="kyc-card-body KYCGroupCompany images_bg">
												<div className="kyc-card-header">
													<div className="kyc-card-title">
														<img src={KYCGroupCompanyImage} alt="Img" />
														<span>
															{getCardTitle(groupCompanyCount, "Groups Company", [
																"totalCount",
																"total",
															])}
														</span>
													</div>
												</div>
												<div className="kyc-card-stats">
													<div className="card_counts text-left">
														<h5 className="text-white mb-2">
															{Object.keys(groupCompanyCount).length > 0
																? groupCompanyCount.withSAPCodeCount ||
																groupCompanyCount.withSAPCode
																: "-"}
														</h5>
														<h6 className="text-white mb-0">With SAP Code</h6>
													</div>
													<div className="kyc-border-right-white border-right-lighten-3"></div>
													<div className="card_counts text-left">
														<h5 className="text-white mb-2">
															{Object.keys(groupCompanyCount).length > 0
																? groupCompanyCount.withoutSAPCodeCount ||
																groupCompanyCount.withoutSAPCode
																: "-"}
														</h5>
														<h6 className="text-white mb-0">Without SAP Code</h6>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>

								{/* Card 2 - Account Name */}
								<div className="col-xl-4 col-lg-6 col-12">
									<div className="card kycbg_yellow">
										<div className="card-content">
											<div className="kyc-card-body KYCAccountName images_bg">
												<div className="kyc-card-header">
													<div className="kyc-card-title">
														<img src={KYCAccountNameImage} alt="Img" />
														<span>
															{getCardTitle(accountNameCount, "Account Name", [
																"totalCount",
																"total",
															])}
														</span>
													</div>
												</div>
												<div className="kyc-card-stats">
													<div className="card_counts text-left">
														<h5 className="text-white mb-2">
															{getCardCountValue(accountNameCount, [
																"ship_To_Party",
																"shipToParty",
															])}
														</h5>
														<h6 className="text-white mb-0">Ship to Party</h6>
													</div>
													<div className="kyc-border-right-white border-right-lighten-3"></div>
													<div className="card_counts text-left">
														<h5 className="text-white mb-2">
															{getCardCountValue(accountNameCount, [
																"bill_To_Party",
																"billToParty",
															])}
														</h5>
														<h6 className="text-white mb-0">Bill to Party</h6>
													</div>
													<div className="kyc-border-right-white border-right-lighten-3"></div>
													<div className="card_counts text-left">
														<h5 className="text-white mb-2">
															{getCardCountValue(accountNameCount, ["payer"])}
														</h5>
														<h6 className="text-white mb-0">Payer</h6>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>

								{/* Card 3 - Contacts */}
								<div className="col-xl-4 col-lg-6 col-12">
									<div className="card kycbg_red">
										<div className="card-content">
											<div className="kyc-card-body KYCContacts images_bg">
												<div className="kyc-card-header">
													<div className="kyc-card-title">
														<img src={KYCContactsImage} alt="Img" />
														<span>
															{getCardTitle(contactsCount, "Contacts", [
																"totalCount",
																"total",
															])}
														</span>
													</div>
												</div>
												<div className="kyc-card-stats">
													<div className="card_counts text-left">
														<h5 className="text-white mb-2">
															{Object.keys(contactsCount).length > 0
																? contactsCount.running
																: "-"}
														</h5>
														<h6 className="text-white mb-0">Running</h6>
													</div>
													<div className="kyc-border-right-white border-right-lighten-3"></div>
													<div className="card_counts text-left">
														<h5 className="text-white mb-2">
															{Object.keys(contactsCount).length > 0
																? contactsCount.hide
																: "-"}
														</h5>
														<h6 className="text-white mb-0">Hide</h6>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>

								{/* Card 4 - Materials */}
								<div className="col-xl-4 col-lg-6 col-12">
									<div className="card kycbg_blue">
										<div className="card-content">
											<div className="kyc-card-body KYCMaterials images_bg">
												<div className="kyc-card-header">
													<div className="kyc-card-title">
														<img src={KYCMaterialsImage} alt="Img" />
														<span>
															{getCardTitle(materialsCount, "Materials", [
																"totalCount",
																"total",
															])}
														</span>
													</div>
												</div>
												<div className="kyc-card-stats">
													<div className="card_counts text-left">
														<h5 className="text-white mb-2">
															{Object.keys(materialsCount).length > 0
																? materialsCount.running
																: "-"}
														</h5>
														<h6 className="text-white mb-0">Running</h6>
													</div>
													<div className="kyc-border-right-white border-right-lighten-3"></div>
													<div className="card_counts text-left">
														<h5 className="text-white mb-2">
															{Object.keys(materialsCount).length > 0
																? materialsCount.hide
																: "-"}
														</h5>
														<h6 className="text-white mb-0">Hide</h6>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>

								{/* Card 5 - Designs */}
								<div className="col-xl-4 col-lg-6 col-12">
									<div className="card kycbg_grey">
										<div className="card-content">
											<div className="kyc-card-body KYCDesign images_bg">
												<div className="kyc-card-header">
													<div className="kyc-card-title">
														<img src={KYCDesignImage} alt="Img" />
														<span>
															{getCardTitle(designsCount, "Designs", [
																"totalCount",
																"total",
															])}
														</span>
													</div>
												</div>
												<div className="kyc-card-stats">
													<div className="card_counts text-left">
														<h5 className="text-white mb-2">
															{Object.keys(designsCount).length > 0
																? designsCount.running
																: "-"}
														</h5>
														<h6 className="text-white mb-0">Running</h6>
													</div>
													<div className="kyc-border-right-white border-right-lighten-3"></div>
													<div className="card_counts text-left">
														<h5 className="text-white mb-2">
															{Object.keys(designsCount).length > 0
																? designsCount.hide
																: "-"}
														</h5>
														<h6 className="text-white mb-0">Hide</h6>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>

								{/* Card 6 - Cylinders */}
								<div className="col-xl-4 col-lg-6 col-12">
									<div className="card kycbg_purple">
										<div className="card-content">
											<div className="kyc-card-body KYCCylinders images_bg">
												<div className="kyc-card-header">
													<div className="kyc-card-title">
														<img src={KYCCylindersImage} alt="Img" />
														<span>
															{getCardTitle(cylindersCount, "Cylinders", [
																"totalCount",
																"total",
															])}
														</span>
													</div>
												</div>
												<div className="kyc-card-stats">
													<div className="card_counts text-left">
														<h5 className="text-white mb-2">
															{Object.keys(cylindersCount).length > 0
																? cylindersCount.running
																: "-"}
														</h5>
														<h6 className="text-white mb-0">Running</h6>
													</div>
													<div className="kyc-border-right-white border-right-lighten-3"></div>
													<div className="card_counts text-left">
														<h5 className="text-white mb-2">
															{Object.keys(cylindersCount).length > 0
																? cylindersCount.close
																: "-"}
														</h5>
														<h6 className="text-white mb-0">Close</h6>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</Spin>
						<Card className="kyc-filter-toggle-card" bodyStyle={{ padding: "0" }}>
							<button
								type="button"
								className={`kyc-filter-toggle-btn ${isFiltersExpanded ? "expanded" : "collapsed"}`}
								aria-expanded={isFiltersExpanded}
								onClick={() => setIsFiltersExpanded((prev) => !prev)}>
								<p>Global Filters</p>
								{isFiltersExpanded ? (
									<MinusOutlined className="kyc-filter-toggle-icon" />
								) : (
									<PlusOutlined className="kyc-filter-toggle-icon" />
								)}
							</button>
						</Card>
						<div
							className={`kyc-filter-panel-wrapper ${isFiltersExpanded ? "expanded" : "collapsed"}`}
							style={{ maxHeight: isFiltersExpanded ? `${filterPanelHeight}px` : "0px" }}>
							<div ref={filterPanelContentRef}>
								<Card className="kyc-filter-panel">
									<div className="kyc-filter-panel-header">
										<h5>Global Filters</h5>
										<Button
											type="link"
											className="kyc-filter-reset"
											onClick={handleResetFilters}>
											<span
												className="reset_filter_spn"
											>
												Reset filter
												<img src={imgFilter} alt="img" className="pb_5" />
											</span>
										</Button>
									</div>
									<Spin spinning={isFiltersLoading}>
										<div className="row drawer-content filter_dropdown drawer-select">
											<div className="col-xl-3 col-lg-4 col-md-6 col-12 mb-20 col-xxl-5-custom">
												<DatePicker
													placeholder="From Date"
													value={filterValues.fromDate}
													format="DD-MM-YYYY"
													onChange={(value) => handleFilterValueChange("fromDate", value)}
												/>
											</div>
											<div className="col-xl-3 col-lg-4 col-md-6 col-12 mb-20 col-xxl-5-custom">
												<DatePicker
													placeholder="To Date"
													value={filterValues.toDate}
													format="DD-MM-YYYY"
													onChange={(value) => handleFilterValueChange("toDate", value)}
												/>
											</div>
											{filterFieldConfigs.map((field) => (
												<div className="col-xl-3 col-lg-4 col-md-6 col-12 mb-20 col-xxl-5-custom" key={field.key}>
													<Select
														mode="multiple"
														allowClear
														showSearch
														optionFilterProp="children"
														placeholder={field.placeholder}
														value={filterValues[field.key]}
														onChange={(value) => handleFilterValueChange(field.key, value)}>
														{filterOptions[field.key].map((option) => (
															<Option key={option.key} value={option.value}>
																{option.label}
															</Option>
														))}
													</Select>
												</div>
											))}
										</div>
									</Spin>
								</Card>
							</div>
						</div>
						<div className="row dashboard_tabs material_tabs">
							<div className="col-12">
								<Card className="kyc-table-card">
									<div className="kyc-table-header">
										<h5 className="kyc-company-title">Company Navigation</h5>
										<div className="tab_searchtxt">
											<Search
												placeholder="Search..."
												className="dash_search"
												allowClear
												size="large"
												value={tableSearchValue}
												onChange={handleTableSearchChange}
												disabled={
													activeCompanyTab !== "groupCompany" &&
													activeCompanyTab !== "account" &&
													activeCompanyTab !== "materials"
												}
											/>
										</div>
									</div>
									<Tabs
										activeKey={activeCompanyTab}
										className="dash_tab_panel kyc_company_tabs"
										type="card"
										onChange={handleCompanyTabChange}>
										<TabPane tab="Group Company" key="groupCompany">
											<KycGroupCompanyTab
												tabTableData={groupCompanyTable}
												isLoading={isGroupCompanyLoading}
												tableSorter={groupCompanySorter}
												OnhandleTableSortColumn={handleGroupCompanyTableChange}
												selectedGroupCompanyId={selectedGroupCompanyId}
												onOpenAccountTab={handleOpenAccountTab}
											/>
										</TabPane>
										<TabPane tab="Account" key="account">
											<KycAccountTab
												tabTableData={accountTable}
												isLoading={isAccountLoading}
												tableSorter={accountSorter}
												OnhandleTableSortColumn={handleAccountTableChange}
												onOpenMaterialsByCustomer={handleOpenMaterialsForAccountCustomer}
											/>
										</TabPane>
										<TabPane tab="Materials" key="materials">
											<KycMaterialsTab
												tabTableData={materialsTable}
												isLoading={isMaterialsLoading}
												tableSorter={materialsSorter}
												OnhandleTableSortColumn={handleMaterialsTableChange}
											/>
										</TabPane>
										<TabPane tab="Quotation" key="quotation">
											<div className="kyc-tab-placeholder">
												Quotation data will appear here once the API is ready.
											</div>
										</TabPane>
										<TabPane tab="Orders" key="orders">
											<div className="kyc-tab-placeholder">
												Orders data will appear here once the API is ready.
											</div>
										</TabPane>
										<TabPane tab="Design" key="design">
											<div className="kyc-tab-placeholder">
												Design data will appear here once the API is ready.
											</div>
										</TabPane>
									</Tabs>
								</Card>
							</div>
						</div>
							</Fragment>
						)}
					</div>
				</div>
			</div>
		</Fragment>
	);
};

const KycMapView = () => (
	<Card className="kyc-map-card">
		<h4>Map View</h4>
	</Card>
	// <Card className="kyc-map-card">
	// 	<div className="kyc-map-filters">
	// 		<Select
	// 			allowClear
	// 			showSearch
	// 			optionFilterProp="children"
	// 			placeholder="Select Group Company Name">
	// 			{mapFilterOptions.groupCompanies.map((company) => (
	// 				<Option key={company} value={company}>
	// 					{company}
	// 				</Option>
	// 			))}
	// 		</Select>
	// 		<Select
	// 			allowClear
	// 			showSearch
	// 			optionFilterProp="children"
	// 			placeholder="Select Company Name">
	// 			{mapFilterOptions.companies.map((company) => (
	// 				<Option key={company} value={company}>
	// 					{company}
	// 				</Option>
	// 			))}
	// 		</Select>
	// 		<Select
	// 			allowClear
	// 			showSearch
	// 			optionFilterProp="children"
	// 			placeholder="Select Location">
	// 			{mapFilterOptions.locations.map((location) => (
	// 				<Option key={location} value={location}>
	// 					{location}
	// 				</Option>
	// 			))}
	// 		</Select>
	// 		<Button className="kyc-map-apply-btn">Apply</Button>
	// 	</div>
	// 	<div className="kyc-map-layout">
	// 		<div className="kyc-static-map">
	// 			{googleMapApiKey ? (
	// 				<LoadScript googleMapsApiKey={googleMapApiKey}>
	// 					<GoogleMap
	// 						mapContainerClassName="kyc-google-map"
	// 						center={mapCenter}
	// 						zoom={8}
	// 						options={googleMapOptions}>
	// 						{mapMarkers.map((marker) => (
	// 							<Marker
	// 								key={marker.id}
	// 								position={marker.position}
	// 								title={marker.title}
	// 								icon={markerIcons[marker.type]}
	// 							/>
	// 						))}
	// 					</GoogleMap>
	// 				</LoadScript>
	// 			) : (
	// 				<div className="kyc-map-missing-key">
	// 					Google Maps API key is missing. Add REACT_APP_GOOGLE_MAPS_API_KEY in
	// 					the environment file.
	// 				</div>
	// 			)}
	// 			<div className="kyc-map-legend">
	// 				<span>
	// 					<EnvironmentFilled className="group" />
	// 					Group Company
	// 				</span>
	// 				<span>
	// 					<EnvironmentFilled className="company" />
	// 					Company
	// 				</span>
	// 			</div>
	// 		</div>
	// 		<aside className="kyc-map-info">
	// 			<h4>Contact Information</h4>
	// 			<div className="kyc-contact-heading">
	// 				<EnvironmentFilled />
	// 				<strong>Company Name</strong>
	// 			</div>
	// 			<p>
	// 				Flat Number 72, First Floor B Block, GT Road, New Amritsar, Near
	// 				Mahajan Kiryana Store, Amritsar - 143001, Punjab, India
	// 			</p>
	// 			<p>Mobile No - +91 1234567890</p>
	// 			<div className="kyc-map-divider" />
	// 			<h4>Account Information</h4>
	// 			<div className="kyc-account-info-card">
	// 				{accountInfoItems.map((item) => (
	// 					<div className="kyc-account-info-row" key={`${item[0]}-${item[2]}`}>
	// 						<div>
	// 							<strong>{item[0]}</strong>
	// 							<span>{item[1]}</span>
	// 						</div>
	// 						<div>
	// 							<strong>{item[2]}</strong>
	// 							<span>{item[3]}</span>
	// 						</div>
	// 					</div>
	// 				))}
	// 				<div className="kyc-account-info-row single">
	// 					<div>
	// 						<strong>Material Group:</strong>
	// 						<span>Flexible Packaging</span>
	// 					</div>
	// 				</div>
	// 			</div>
	// 		</aside>
	// 	</div>
	// </Card>
);

export default KycDashboard;
